import { render, staticRenderFns } from "./SidebarTile.vue?vue&type=template&id=0cea6e5f"
import script from "./SidebarTile.vue?vue&type=script&lang=js"
export * from "./SidebarTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports